// modules/BlackTitleBar.js
import React        from 'react';

class TitleBar extends React.Component {
	render() {
		return (
			<div className="black-title-bar">
				<div className={this.props.type}>{this.props.children}</div>
			</div>
		);
	}
}

export default TitleBar;


/** WEBPACK FOOTER **
 ** ./src/modules/common/TitleBar.js
 **/